import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import GoogleLogin from 'react-google-login'

import logo from 'assets/images/logo-gc.png'

import config from 'configpath'

import Styles from './index.scss'

const Form = props => (
  <form name="login-form" className="login-form" onSubmit={props.submitSignin(props.auth)}>
    <div className="logo">
      <Link to="/">
        <img src={logo} style={{ width: '200px' }} alt="logo" />
      </Link>
    </div>
    <h3 className="form-title font-green">Admin Panel <br /><small>Sign In</small></h3>
    <div className="alert alert-danger display-hide">
      <button className="close" data-close="alert" />
      <span>
          Enter email and password.
        </span>
    </div>
    {props.auth.isError && (
      <div className="form-group">
        <div className="alert alert-danger">
          <strong>Whoops!</strong> {props.auth.errorMessage}
        </div>
      </div>
    )}
    <div className={Styles['container-btn-google']}>
      <GoogleLogin
        clientId={config.googleWebClientId}
        onSuccess={(res) => { props.signinWithGoogle({ access_token: res.accessToken }) }}
        onFailure={(res) => { props.signinWithGoogle({ error: res }) }}
        render={renderProps => (
          <button
            onClick={renderProps.onClick}
            className="google-icon"
          >
            Continue With Google
          </button>
        )}
      />
    </div>
  </form>
)

Form.defaultProps = {
  auth: {
    signin: {
      email: '',
      password: '',
    },
    isError: false,
    errorMessage: '',
  },
}

Form.propTypes = {
  auth: PropTypes.shape({
    signinData: PropTypes.shape({
      email: PropTypes.string.isRequired,
      password: PropTypes.string.isRequired,
    }).isRequired,
    isError: PropTypes.bool,
    errorMessage: PropTypes.string,
  }).isRequired,
  submitSignin: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  signinWithGoogle: PropTypes.func.isRequired,
}

export default Form
